module.exports = __webpack_public_path__ + "img/nn2000.931a57bb.jpg";